import {colors} from "@indebted/theme/colors"
import {OfferStatus} from "@indebted/api/customerOffersAPI"

const statusColors: Record<OfferStatus, string> = {
	available: colors.success["600"],
	upcoming: colors.warning["500"],
	expired: colors.gray["300"],
	revoked: colors.gray["300"],
	none: colors.gray["300"],
}

export function offerStatusColors(status: OfferStatus): string {
	return statusColors[status]
}
